const TEMPLATE_TYPES = ["failures", "events", "illuminate_content", "collector_logs"];
export const isTemplateTypeAllowsFieldTypeChang = (type) => !TEMPLATE_TYPES.includes(type);
const isIndexFieldTypeChangeAllowed = (indexSet) => isTemplateTypeAllowsFieldTypeChang(indexSet == null ? void 0 : indexSet.index_template_type);
export default isIndexFieldTypeChangeAllowed;
